import React, { useState } from 'react';
import Header from './components/Header';
import Content from './components/Content';
import { Transparency } from 'Screens/Contextualization/Host/components/HostDetail/styled';
import Wrapper from './styled';

const UserAgentDetail = ({ tabRef, onScroll, showTransparency, setTriggerWarning }) => {
  const [toolToSave, setToolToSave] = useState({});
  const [toolExpanded, setToolExpanded] = useState(null);

  return (
    <Wrapper>
      <Header toolExpanded={ toolExpanded } />
      { showTransparency && <Transparency /> }
      <Content tabRef={ tabRef } onScroll={ onScroll } showTransparency={ showTransparency } toolToSave={ toolToSave } setToolToSave={ setToolToSave } setTriggerWarning={ setTriggerWarning } toolExpanded={ toolExpanded } setToolExpanded={ setToolExpanded } />
    </Wrapper>
  );
};

export default UserAgentDetail;
